<template>
    <v-container class="fill-height" fluid style="background-color: gray">
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
                <v-card class="elevation-12" color="grey lighten-4">
                    <v-toolbar color="bal-red" dark flat>
                        <v-img contain max-height="50px" :src="require('../../assets/images/Balsnack-logo.png')" />
                    </v-toolbar>
                    <v-card-text v-if="step === 'forgot-password'">
                        <v-list-item-title class="headline mb-1">Reset password</v-list-item-title>
                        <v-list-item-subtitle>For resetting password insert your email.</v-list-item-subtitle>
                        <v-form>
                            <v-text-field
                                color="bal-red"
                                label="Email"
                                name="login"
                                prepend-icon="person"
                                type="text"
                                :rules="[
                                    v =>
                                        !v ||
                                        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                                        'E-mail must be valid'
                                ]"
                                v-model="user.email"
                                @input="updateField($event, 'email')"
                            />
                        </v-form>
                    </v-card-text>
                    <v-card-text v-else-if="step === 'sent'">
                        <v-list-item-subtitle>Password link was sent to your email account.</v-list-item-subtitle>
                        <v-list-item-subtitle>Please check your mailbox.</v-list-item-subtitle>
                    </v-card-text>
                    <v-card-text v-else-if="step === 'sent_error'">
                        <v-list-item-subtitle style="font-weight: bold; color: red;"
                            >There was problems with sending out an email.</v-list-item-subtitle
                        >
                        <v-list-item-subtitle style="font-style: italic"
                            >Please try again or contact with admin.</v-list-item-subtitle
                        >
                    </v-card-text>
                    <v-card-text v-else>
                        <v-form>
                            <v-text-field
                                color="bal-red"
                                label="Email"
                                name="login"
                                prepend-icon="person"
                                type="text"
                                :rules="[
                                    v =>
                                        !v ||
                                        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                                        'E-mail must be valid'
                                ]"
                                v-model="user.email"
                                @input="updateField($event, 'email')"
                            />

                            <v-text-field
                                id="password"
                                label="Password"
                                name="password"
                                prepend-icon="lock"
                                type="password"
                                v-model="user.password"
                                @input="updateField($event, 'password')"
                            />
                        </v-form>
                        <a href="#forgot" @click="step = 'forgot-password'">Forgot password?</a>
                        <v-alert v-model="user.error" type="error" color="bal-red">
                            Wrong email or password
                        </v-alert>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer />
                        <v-btn v-if="step === 'forgot-password'" color="bal-red" dark @click="step = 'login'"
                            >Back</v-btn
                        >
                        <v-btn v-if="step === 'forgot-password'" color="bal-red" dark @click="handleResetClick"
                            >Send</v-btn
                        >
                        <v-btn v-if="step === 'login'" color="bal-red" dark @click="handleLoginClick">Login</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Store from "../../store";

export default {
    name: "login",
    data() {
        return {
            step: "login"
        };
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    computed: {
        ...mapState(["user"])
    },
    methods: {
        ...mapActions(["login", "resetPassword"]),
        updateField(value, field) {
            Store.commit("updateUserProperty", { prop: field, value: value });
        },
        handleLoginClick() {
            this.login(this.user);
        },
        async handleResetClick() {
            const response = await this.resetPassword(this.user);
            console.log(response);
            if (response && response.success === 1) {
                this.step = "sent";
            } else {
                this.step = "sent_error";
            }
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 13) {
                this.handleLoginClick();
            }
        }
    }
};
</script>

<style scoped></style>
